<template>
    <LayoutSub :parent="this.$route.meta.groupName" className="digital_gift">
        <SubpageTitleContainer :title="`이지캐시(EasyCash)`"
            :subText="`고객이 디지털 상품권을 구매/충전한 후 구매 금액만큼 차감하는 방식으로 사용하는 선불 서비스입니다. <br />가맹점에서는 고객에게 다양한 혜택을 부여함으로써 효과적인 마케팅 수단으로 활용할 수 있습니다.`">
        </SubpageTitleContainer>

        <SubSection class="pt-0">
            <div class="grid-3 scroll">
                <CardBox idx="1" title="다양한 상품권 종류" :list="['카드형 상품권', '모바일 상품권 (MMS)', '고객사 APP 연동 기능']" />
                <CardBox idx="2" title="연동 및 관리 용이"
                    :list="['상품권 충전 및 발송 등 관리자 페이지를 통한 <br />손쉬운 관리 가능', '다양한 조건에 따른 거래실적 집게 데이터 제공']" />
                <CardBox idx="3" title="안정적인 운영 지원"
                    :list="['전담 운영을 위한 인원 배치', '장애 사전 감지 및 대응을 위한 시스템/네트워크 <br />모니터링']" />
            </div>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">효과</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid src="sub8_icon_1.png" title="신규고객 유치"
                    content="선물, B2B 배포, 외부 판매를 통한 신규 고객 유인 및 매출 향상" />
                <TableRow_2grid src="sub8_icon_2.png" title="Lock-in 효과" content="디지털 상품권과 포인트 서비스 연계를 통한 고객 고정화" />
                <TableRow_2grid src="sub8_icon_3.png" title="선수금 활용" content="상품권 판매로 선수금 이자수익, 미래 매출에 대한 현금 확보 가능 " />
                <TableRow_2grid src="sub8_icon_4.png" title="낙전 수익" content="상품권 분실, 유효기간 내 미사용 등으로 인한 미회수퇴장수익 발생 " />
                <TableRow_2grid src="sub8_icon_5.png" title="매출 Shift 효과"
                    content="상품권 금액 및 고객 결제수단 대비 약 140% 매출 Shift 효과 발생  " />
                <TableRow_2grid src="sub8_icon_6.png" title="선매 효과" content="상품권 판매와 재화, 용역 제공 시점 차이로 인한 선매 효과 발생" />
            </div>
        </SubSection>

        <SubSection class="pb-0">
            <SubTitle3 listStyle="dot">시스템 구성</SubTitle3>
            <div class="system_composition_container">
                <div class="row">
                    <div class="col">
                        <div class="line_box">
                            <div class="line_box_header">
                                <div class="header-title-area">단말기</div>
                            </div>
                            <div class="line-box-body">
                                <div class="content">
                                    <div class="card-box">
                                        <p class="card-box-title">유선 CAT</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_7.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="card-box">
                                        <p class="card-box-title">무선 CAT</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_8.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="card-box">
                                        <p class="card-box-title">POS</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_9.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ic_down_arrow">
                            <img src="@/assets/ic_down_arrow.png" alt="" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="line_box">
                            <div class="line_box_header">
                                <div class="header-title-area">카드 매체</div>
                            </div>
                            <div class="line-box-body">
                                <div class="content">
                                    <div class="card-box">
                                        <p class="card-box-title">MS/IC 카드</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_10.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="card-box">
                                        <p class="card-box-title">바코드</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_11.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="card-box">
                                        <p class="card-box-title">스마트폰</p>
                                        <div class="card-box-image">
                                            <img src="@/assets/sub8_icon_12.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ic_down_arrow">
                            <img src="@/assets/ic_down_arrow.png" alt="" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="line_box">
                        <div class="line_box_header">
                            <div class="header-title-area">주요 기능</div>
                        </div>
                        <div class="line-box-body">
                            <div class="content">
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">가맹점관리</p>
                                    <ul class="inner_line_box_list">
                                        <li>회원사</li>
                                        <li>가맹점</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">발급</p>
                                    <ul class="inner_line_box_list">
                                        <li>카드매체</li>
                                        <li>권종</li>
                                        <li>디자인</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">충전 (판매)</p>
                                    <ul class="inner_line_box_list">
                                        <li>초기 설정</li>
                                        <li>충전 관리</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">사용 (회수)</p>
                                    <ul class="inner_line_box_list">
                                        <li>승인, 취소</li>
                                        <li>잔액 관리</li>
                                        <li>한도 관리</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">정산</p>
                                    <ul class="inner_line_box_list">
                                        <li>가맹점 정산</li>
                                        <li>수수료 정산</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">관리</p>
                                    <ul class="inner_line_box_list">
                                        <li>재발급, BL</li>
                                        <li>전액 환불</li>
                                        <li>폐기 관리</li>
                                    </ul>
                                </div>
                                <div class="inner_line_box">
                                    <p class="inner_line_box_title">제휴/프로모션</p>
                                    <ul class="inner_line_box_list">
                                        <li>사용 제휴</li>
                                        <li>CPM</li>
                                        <li>프로모션</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox from '@/components/CardBox.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        CardBox,
        TableRow_2grid,
    },
};
</script>
